<template>
  <div class="container">
    <dictamen-datatable />
  </div>
</template>

<script>
import DictamenDatatable from "./dictamen_datatable/Index.vue";

export default {
  name: "DictamenIndex",
  components: { DictamenDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
